import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import Companies from '../../../components/Companies';
import { useApp } from '../../../contexts/App';
import homePageCompanies from '../../../data/companies';
import { colors } from '../../../styles/constants';
import Newsletter from '../../Newsletter';
import SearchHeader from '../../SearchHeader';
import App from './App';
import Concept from './Concept';
import Destinations from './Destinations';
import FAQ from './FAQ';
import Highlight from './Highlight';
import { homepageMessages } from './messages';
import Review from './Review';
import TravelList from './TravelList';

export const Wrapper = styled.div`
  ${tw`relative p-big flex flex-col overflow-hidden z-0`}
  gap:var(--size-big);

  @media (min-width: 1200px) {
    padding-right: 116px;
    padding-left: 116px;
  }
`;

const TravelistContainer = styled.div`
  ${tw`relative`}

  @media (min-width: 992px) {
    &:after {
      z-index: -1;
      content: ' ';
      position: absolute;
      background: radial-gradient(
        43.16% 43.16% at 50% 50%,
        rgba(34, 227, 170, 0.6) 0%,
        rgba(215, 243, 229, 0) 100%
      );
      width: 579.2109365188024px;
      right: -376px;
      top: 0px;
      border-radius: 0px;
      bottom: -363px;
    }

    &:before {
      z-index: -1;
      content: ' ';
      position: absolute;
      background: radial-gradient(
        43.16% 43.16% at 50% 50%,
        rgba(106, 73, 249, 0.2) 0%,
        rgba(215, 243, 229, 0) 100%
      );
      width: 579.2109365188024px;
      right: -172px;
      top: 0px;
      border-radius: 0px;
      bottom: -824px;
    }
  }
`;
interface HomePageViewProps {
  isReduce: boolean;
}

const HomePageView: React.FC<HomePageViewProps> = ({ isReduce }) => {
  const { partner } = useApp();
  const [isTravelSearchBarPanelOpen, setIsTravelSearchBarPanelOpen] =
    useState<boolean>(false);

  return (
    <React.Fragment>
      <SearchHeader
        header={partner?.header}
        partner={partner}
        setIsTravelSearchBarPanelOpen={setIsTravelSearchBarPanelOpen}
        subHeader={partner?.subHeader}
      />

      {!isReduce && !partner && (
        <Wrapper>
          <Companies
            images={homePageCompanies.map((company) => {
              const addLink = [
                'SNCF',
                'Flixbus',
                'Blablacar',
                'Ouigo',
              ].includes(company.name);

              return {
                image: company.logo,
                linkUrl: addLink ? company.url : undefined,
                openLinkInNewTab: addLink ? company.openInNewTab : undefined,
              };
            })}
            stopAnimatedCards={isTravelSearchBarPanelOpen}
            subtitle={<FormattedMessage {...homepageMessages.companiesText} />}
            title={
              <React.Fragment>
                <FormattedMessage {...homepageMessages.companiesTitle1} />{' '}
                <span
                  style={{
                    color: colors['primary-400'],
                  }}
                >
                  <FormattedMessage {...homepageMessages.companiesTitle2} />
                </span>
              </React.Fragment>
            }
          />
          <Highlight />
          <Concept />
          <App />
          <Review />
          <Destinations />
          <Newsletter />
          <FAQ />
          <TravelistContainer>
            <TravelList />
          </TravelistContainer>
        </Wrapper>
      )}
    </React.Fragment>
  );
};

export default HomePageView;
